export default __webpack_public_path__ + "static/media/mush1.a480f245.jpg";